module.exports = __webpack_public_path__ + "static/media/camp2.825b4821.jpeg";